module.exports = __webpack_public_path__ + "static/concept1-sp-bcb09bc12f5ed9a6c5971609cff6045c.svg";